/**************************************************
 * Nombre:       Home_Banner
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Lottie from 'react-lottie';
import anima from '../../../Recursos/Animaciones/animacion.json'
import fondo from '../../../Recursos/fondo_banner.png'
import logo from '../../../Recursos/logo_blanco.svg'
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Home_Banner = () => {
    const {sCell} = useResponsive()


    let opciones = {
        loop: true,
        autoplay: true,
        animationData: anima,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
            animationEasing: 'ease-in-out',
        }
    };

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
        sx={{
            backgroundImage: `url(${fondo})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
        }}
        >

            <Grid
                container
                justifyContent={'flex-start'}
                direction={'row-reverse'}
                alignItems={'flex-end'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    maxWidth: '1400px',
                    px: sCell ? 0 : 3,

                }}
            >


                <Grid container size={{xs: 12, sm: 12, md: 7}}
                      sx={{justifyContent: 'flex-end', pb: 3, pt: sCell ? 4 : 0, pr: sCell ? 4 : 0}}>
                    <img src={logo} width={sCell ? 120 : 200} height={'auto'}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 5}} sx={{justifyContent: 'flex-start',mt: sCell ? -12 : -0}}>
                    <Lottie
                        // ref={ref}
                        options={opciones}
                        height={'auto'}
                        speed={0.3}
                        width={'100%'}/>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Home_Banner